<template>
    <footer>
    </footer>
</template>

<script>
export default {
  name: "footer-layout"
}
</script>